module.exports = __webpack_public_path__ + "img/02.0647c3f1.png";